/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const MessagesRegularV6 = (props) => (
  <Icon {...props} name="Messages Regular V6">
    <path d="M10.4 3.178V8a1.6 1.6 0 0 1-1.6 1.598L5.6 9.6l-2.723 1.54a.299.299 0 0 1-.478-.24V9.6h-.8c-.881 0-1.6-.717-1.6-1.6V3.178c0-.859.719-1.577 1.6-1.577h7.2c.883 0 1.6.719 1.6 1.577zM3.6 9.353 5.285 8.4H8.8c.218 0 .4-.18.4-.4V3.2c0-.219-.182-.4-.4-.4H1.6c-.219 0-.4.181-.4.4V8c0 .22.181.4.4.4h2v.953zM6.4 11.2v-.8h1.2v.8c0 .218.18.4.4.4h2.715l1.685.953V11.6h2c.218 0 .4-.182.4-.4V6.4c0-.218-.182-.4-.4-.4h-3.2V4.8h3.2c.883 0 1.6.718 1.6 1.577v4.822a1.6 1.6 0 0 1-1.6 1.6h-.8v1.3a.299.299 0 0 1-.477.24l-2.723-1.54-2.4-.002c-.88 0-1.6-.715-1.6-1.598z" />
  </Icon>
);

export default MessagesRegularV6;
